export default {
  documentTitle: 'KeyPal硬件錢包-守護你的數字資產',
  product: '產品',
  learn: '學習',
  support: '支持',
  others: '其他',
  language: '語言',
}
